import React from 'react';
type AdvisorsSvgProps = {
  stroke: string;
};

export const OthersSvg: React.FC<AdvisorsSvgProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1055_3999)">
      <path
        d="M16.0828 17.518C16.0972 17.7446 15.9251 17.9401 15.6984 17.9545L5.35969 18.6113C4.76066 18.6493 4.24412 18.1947 4.20574 17.5957L3.36594 4.48621C3.32981 3.92229 3.75828 3.43613 4.32227 3.40112C4.90712 3.36481 5.40262 3.82682 5.40727 4.41278L5.50002 16.0996C5.50478 16.6996 5.99462 17.1823 6.59457 17.1782L16.0133 17.1145C16.0375 17.1133 16.0582 17.1317 16.0598 17.1559L16.0828 17.518Z"
        fill={props.stroke}
      />
      <path
        d="M15.4273 0.250244C15.2101 0.0330904 14.9156 -0.0889053 14.6085 -0.0889053H7.52694C6.88744 -0.0889053 6.36902 0.429516 6.36902 1.06902V14.9895C6.36902 15.629 6.88744 16.1474 7.52694 16.1474H17.8419C18.4814 16.1474 18.9998 15.629 18.9998 14.9895V4.30245C18.9998 3.99535 18.8778 3.70083 18.6607 3.48367L15.4273 0.250244ZM16.3206 14.0729H9.43104C9.21976 14.0729 9.04828 13.9015 9.04828 13.6902C9.04828 13.4789 9.21976 13.3074 9.43104 13.3074H16.3206C16.5319 13.3074 16.7033 13.4789 16.7033 13.6902C16.7033 13.9015 16.5319 14.0729 16.3206 14.0729ZM16.3206 11.2454H9.43104C9.21976 11.2454 9.04828 11.0739 9.04828 10.8627C9.04828 10.6514 9.21976 10.4799 9.43104 10.4799H16.3206C16.5319 10.4799 16.7033 10.6514 16.7033 10.8627C16.7033 11.0739 16.5319 11.2454 16.3206 11.2454ZM16.3206 8.41788H9.43104C9.21976 8.41788 9.04828 8.24641 9.04828 8.03513C9.04828 7.82385 9.21976 7.65238 9.43104 7.65238H16.3206C16.5319 7.65238 16.7033 7.82385 16.7033 8.03513C16.7033 8.24641 16.5319 8.41788 16.3206 8.41788Z"
        fill={props.stroke}
      />
      <circle cx="10.5" cy="3.5" r="1.5" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_1055_3999">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
